<template>
    <div>
        <section class="section">
            <DashboardSessionsFilter
                v-model="searchString"
                :filter.sync="selectedType"
            />
        </section>
        <section ref="contentBox" class="section">
            <DashboardSessionsTable :sessions="items" />
        </section>
    </div>
</template>
<script>
import DashboardSessionsTable from '@/components/DashboardSessionsTable';
import DashboardSessionsFilter from '@/components/DashboardSessionsFilter';
import { fetchItems } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        DashboardSessionsTable,
        DashboardSessionsFilter,
    },
    data() {
        return {
            loadingItems: false,
            items: [],
            searchString: this.$route.query.search,
            selectedType: this.$t('Constants.FILTER_OPTION_SESSION_ALL'),
            selectedFilter: this.$route.query.filter || 'mine',
            queryType: this.$route.query.type,
        };
    },
    computed: {
        sessionType() {
            if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_SESSION_ALL')
            ) {
                return undefined;
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_SESSION_TRIVIAL')
            ) {
                return 'trivial';
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_SESSION_TREASUREHUNT')
            ) {
                return 'treasurehunt';
            }
            return undefined;
        },
    },
    watch: {
        '$route.query.filter': function (newValue) {
            if (newValue) {
                this.selectedFilter = newValue;
            }
        },
        '$route.query.type': function (newValue) {
            this.queryType = newValue;
        },
        '$route.query.search': function (newValue) {
            this.searchString = newValue;
        },
        selectedFilter: {
            handler: 'filterHandler',
            immediate: true,
        },
        searchString: {
            handler: 'searchStringHandler',
            immediate: false,
        },
        queryType: {
            handler: 'typeHandler',
            immediate: false,
        },
        selectedType: {
            handler: 'typeHandler',
            immediate: false,
        },
    },
    async mounted() {
        //this.getItems
    },
    methods: {
        async getItems() {
            if (this.loadingItems) {
                // another call is running
                return;
            }
            this.loadingItems = true;
            let response = await fetchItems(`session/${this.selectedFilter}`, {
                title_contains: this.searchString,
                owner_contains: this.searchString,
                shortCode_contains: this.searchString,
                'project.type': this.sessionType,
                _offset: this.offset,
                _limit: this.limit,
            }).finally(() => {
                this.loadingItems = false;
            });
            this.items = response.data;
            /*this.items = this.items.concat(response.data);
            this.offset = this.items.length;
            if (response.data.length < this.limit) {
                this.lastPage = true;
            }*/
        },
        filterHandler() {
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ filter: this.selectedFilter } },
                })
                .catch((e) => {
                    console.log('error selected filter');
                });
            this.resetSearch();
        },
        typeHandler() {
            let query = Object.assign({}, this.$route.query);
            if (query.type !== this.sessionType) {
                this.$router
                    .push({
                        query: { ...query, ...{ type: this.sessionType } },
                    })
                    .catch((e) => {
                        console.log('error selected type', e);
                    });
            }

            this.resetSearch();
        },
        searchStringHandler() {
            if (this.searchString && this.searchString.length == 0) {
                this.searchString = undefined;
            }
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ search: this.searchString } },
                })
                .catch(() => {
                    console.log('error selected string');
                });
            this.resetSearch();
        },
        resetSearch() {
            this.items = [];
            this.getItems();
        },
    },
};
</script>

<style scoped></style>
